import {BehaviorSubject, Observable, Subject} from 'rxjs';

import {Injectable} from '@angular/core';

import {CockpitCard} from '../dtos/cockpit-card';
import {DataSheetFilterData} from '../dtos/datasheet-filter-data';
import {FunctionBknBstGrouped} from '../dtos/function-bkn-bst-grouped';
import {VergleichspaareSortierung} from './storage/vergleichspaare-sortierung.enum';
import {DataStorageService} from './data-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  filterData = new Subject<DataSheetFilterData>();
  resetFilter = new Subject<boolean>();
  functionCodingData = new Subject<FunctionBknBstGrouped[]>();
  complianceRiskPaareSorted = new Subject<VergleichspaareSortierung>();
  functionChanged = new Subject<boolean>();
  isKontrollmodus$: Observable<boolean>;

  private readonly cardData = new Subject<CockpitCard>();
  private readonly isKontrollmodusSubject = new BehaviorSubject<boolean>(false);

  constructor(private readonly storage: DataStorageService) {
    this.isKontrollmodus$ = this.isKontrollmodusSubject.asObservable();
  }

  async init(): Promise<void> {
    this.isKontrollmodusSubject.next(await this.storage.getKontrollmodus());
  }

  getFilterData(): Observable<DataSheetFilterData> {
    return this.filterData.asObservable();
  }

  sendFilterData(data: DataSheetFilterData) {
    this.filterData.next(data);
  }

  getReseteFilter(): Observable<boolean> {
    return this.resetFilter.asObservable();
  }

  sendResetFilter(reset: boolean) {
    this.resetFilter.next(reset);
  }

  getFunctionCodingData(): Observable<FunctionBknBstGrouped[]> {
    return this.functionCodingData.asObservable();
  }

  sendFunctionCodingData(functionBknBstGrouped: FunctionBknBstGrouped[]) {
    this.functionCodingData.next(functionBknBstGrouped);
  }

  getListOfFunctionsChanged(): Observable<boolean> {
    return this.functionChanged.asObservable();
  }

  sendListOfFunctionsChanged(value: boolean) {
    this.functionChanged.next(value);
  }

  getResetChartDialog(): Observable<CockpitCard> {
    return this.cardData.asObservable();
  }

  getSendChartDialog(cardData: CockpitCard) {
    this.cardData.next(cardData);
  }

  getResetCockpitTabExperten(): Observable<boolean> {
    return this.isKontrollmodusSubject.asObservable();
  }

  getSendCockpitTabExperten(value: boolean) {
    this.isKontrollmodusSubject.next(value);
  }
}
